import { ReactNode, ButtonHTMLAttributes } from "react";
import ThemeButton from "./styles";
import { Link } from "react-router-dom";

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  buttonSize: string;
  buttonStyle: string;
  link: string;
}

export const EventButton = ({
  children,
  onClick,
  buttonSize,
  buttonStyle,
}: IButtonProps) => {
  return (
    <ThemeButton
      buttonSize={buttonSize}
      buttonStyle={buttonStyle}
      onClick={onClick}
    >
      {children}
    </ThemeButton>
  );
};

export const FormButton = ({
  children,
  buttonSize,
  buttonStyle,
}: IButtonProps) => {
  return (
    <ThemeButton
      buttonSize={buttonSize}
      buttonStyle={buttonStyle}
      type="submit"
    >
      {children}
    </ThemeButton>
  );
};

export const LinkButton = ({
  children,
  link,
  buttonSize,
  buttonStyle,
}: IButtonProps) => {
  return (
    <Link to={link}>
      <ThemeButton buttonSize={buttonSize} buttonStyle={buttonStyle}>
        {children}
      </ThemeButton>
    </Link>
  );
};
